import { Injectable } from '@angular/core';

import { catchError, filter, map, Observable, throwError } from 'rxjs';
import { City, District, Prop, Province } from '../interfaces/prop.interface';

import { propsJson } from '../data/props.json';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  endpointApi = environment.apiPropUrl;

  result: Prop | undefined;

  constructor(private http: HttpClient) { }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error.msg));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getPropertyById(id: string) {

    return this.http.get<any>(this.endpointApi + 'property/get?uuid=' + id)
      .pipe(
        map(resp => resp.data.property),
        catchError(this.handleError)
      )

    // this.result = propsJson.filter(prop => prop.id === id)[0];
    // return this.result
  }
  getImagesById(id: string) {
    return this.http.get<any>(this.endpointApi + 'images/get?fk_idProp=' + id)
      .pipe(
        map(resp => resp.data.images),
        catchError(this.handleError)
      )

  }

  contactForm(data: any) {
    return this.http.post<any>(this.endpointApi + 'contactform', data)
      .pipe(
        map(resp => resp.data),
        catchError(this.handleError)
      )
  }


}
